<template>
  <!-- 搜索医生页面 -->
  <div id="sd-search">
    <!-- header -->
    <header>
      <div class="search-bar">
        <!-- <img v-if="showBack" src="../../assets/img/see-doctor-icon/2-2fanhui@2x.png" alt="" class="back-icon" @click="backSearch"> -->

        <!-- <div class="search-box" :class="{activeSearch:showBack}"> -->
        <div class="search-box">
          <div class="form-input" ref="formInput">
            <input
              ref="search"
              v-model="searchInput"
              type="search"
              class="search-text"
              placeholder="病种/症状/医生/医院"
              @keyup.enter="goSearch"
            >
          </div>
          <img src="../../assets/img/see-doctor-icon/2-1sousuo@2x.png" alt="" class="search-icon">
          <img
            @click="clearInput"
            v-show="searchInput"
            src="../../assets/img/see-doctor-icon/2-2qingchu@2x.png"
            alt=""
            class="close-icon"
          >
        </div>
        <!-- <span class="back-text" @click='goBack' v-if="!showBack">取消</span> -->

        <span class="back-text" @click="goBack">取消</span>
      </div>
      <!-- 搜索导航 -->
      <div class="search-nav" v-show="navFlag" v-if="!inMiniProgram">
        <ul class="nav-wrapper">
          <li
            @click="selectNav(index)"
            :class="{activeNav:selectFlag===index}"
            class="nav-text"
            v-for="(item,index) in navText"
            :key="index"
          >
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
      <!-- end -->
    </header>
    <!-- end -->
    <!-- 空内容展示 -->
    <div class="null-wrapper" v-if="showFlag">
      <div class="img-wrapper">
        <img src="../../assets/img/queshengye/no-search.png" alt="" class="null-img">
        <span class="null-text">{{nullText}}</span>
        <!-- <span class="null-text">深读君挑灯夜战正在赶制~</span> -->
      </div>
    </div>
    <!-- end -->
    <!-- 首页内容 -->
    <div v-show="true" class="index-content" :class="{nullIndex:showFlag}">
      <!-- <div class="search-scroll" ref="searchScrollRef"> -->
      <div class="text-wrapper">
        <!-- 最近搜索 -->
        <div class="recent-search" v-show="keyFlag" v-if="keyWords.length>0">
          <div class="search-title">
            <span class="title-text">最近搜索</span>
            <span class="delete-search" @click="clearKeyword">清除历史</span>
          </div>
          <ul class="search-list">
            <li
              class="item-text"
              @click="tipsSearch(item)"
              v-for="(item, index) in keyWords"
              :key="index"
            >
              <span>{{item.keyword}}</span>
            </li>
          </ul>
        </div>
        <!-- end -->
        <!-- 全部视频 -->
        <div class="all-video" v-show="allFlag">
          <!--<img src="../../assets/img/askdoctor/banner-GIF.gif" @click="goRouter('SdAskDoctor')" class="ask-gif" alt="">-->

          <p class="all-text">全部视频</p>
          <ul class="all-box">
            <li v-for="(item,index) in groupList" :key="index" class="all-item">
              <div class="search-title">
                <span class="title-text">{{item.title}}</span>
              </div>
              <ul class="search-list">
                <li
                  class="item-text"
                  v-for="(_item,index) in item.group_list"
                  :key="index"
                  @click="tipsSearch(_item)"
                >
                  <span>{{_item.group_name}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- 搜索列表 -->
      <div class="search-scroll" ref="searchScrollRef">
        <!-- <div> -->
        <div class="search-wrapper">
          <ul class="video-list" v-if="videoList.length>0">
            <li class="list-item" v-for="(item,index) in videoList" :key="index">
              <VideoBox :item="item"></VideoBox>
            </li>
          </ul>
          <ul class="doctor-list" v-if="doctorList.length>0 && !inMiniProgram">
            <li class="list-item" v-for="(item,index) in doctorList" :key="index">
              <DoctorItem :item="item"></DoctorItem>
            </li>
          </ul>
          <div class="button-wrapper" v-if="!inMiniProgram">
            <van-button
              v-if="searchList.doctor_hasmore === true && selectFlag === 0"
              type="primary"
              class="more-button"
              @click="selectFlag = 2"
            >查看更多</van-button>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <!-- end -->
    </div>
    <!-- end -->
  </div>
</template>

<script>
  import iMp from "@/common/isMp";
  import DoctorItem from "../public/DoctorDetail";
  import VideoBox from "../public/VideoBox";
  import BScroll from "better-scroll";
  import {
    searchDoctor,
    searchVideo,
    searchGroupList,
    searchAll,
    searchKeyWord,
    searchClearKeyWord
  } from "@/api/index";
  export default {
    data() {
      return {
        selectFlag: 0,
        searchInput: "",
        searchTips: "",
        navText: [{ name: "全部" }, { name: "视频" }, { name: "医生" }],
        groupList: [],
        searchList: {
          videoList: [],
          doctorList: []
        },
        doctorList: [],
        videoList: [],
        keyWords: [],
        showFlag: false, // 控制深度君图片的显示
        nullTxt: "",
        keyFlag: true, // 控制最近搜索的显示
        navFlag: true, // 控制导航的显示
        allFlag: true, // 控制全部视频的显示
        showBack: false,
        backPath: "",
        searchScroll: null,
        doctorParams: {
          // 医生搜索参数
          page: 1,
          number: 10
        },
        videoParams: {
          page: 1,
          number: 3
        },
        searchToast: null // 弹层
      };
    },
    mixins: [iMp],
    watch: {
      // 选择展示内容 0是全部 2是视频 1是医生
      selectFlag(n, o) {
        // this.searchScroll.refresh()
        // this.searchScroll.scrollTo(0, 0)
        switch (n) {
          case 0:
            this.doctorList = this.searchList.doctorList;
            this.videoList = this.searchList.videoList;
            break;
          case 2:
            // this.doctorList = this.searchList.doctorList
            this.doctorList = [];
            this.doctorParams.page = 1;
            this.fetchDoctor();
            this.videoList = "";
            break;
          case 1:
            this.videoList = [];
            this.videoParams.page = 1;
            this.fetchVideo();
            // this.videoList = this.searchList.videoList
            this.doctorList = "";
        }
        // this.nullText()
        this.nullTextJuge();
      },
      searchTips: {
        handler(n, o) {
          this.tipsSearch(n);
          // this.goSearch()
        }
      }
    },
    created() {},
    beforeMount() {
      this.getGroupList();
      this.getKeyword();
      this.nullTextJuge();
      this.showFlag = false;
      // 其他页面的标签搜索
      if (localStorage.getItem("searchText")) {
        this.searchInput = localStorage.getItem("searchText");
        localStorage.removeItem("searchText");
        this.goSearch();
      } else {
      }
    },
    activated() {
      // 每次进来重新挂载滚动
      //this.$nextTick(() => {
      //this.initScroll()
      //})
      if (this.searchTips === this.$route.query.key) {
        this.tipsSearch(this.searchTips);
      } else {
        this.searchTips = this.$route.query.key;
      }
    },
    mounted() {
      if (this.$route.query.key) {
        if (this.$route.query.key.length > 0) {
          this.searchInput = this.$route.query.key;
          this.goSearch();
        }
      }
      this.$root.$on("key", res => {
        this.searchInput = res;
        this.searchTips = this.searchInput;
      });
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (
          from.path === "/SdSeeDoctor" ||
          from.path === "/SdDetailVideo" ||
          from.path === "/SdSeeGroup"
        ) {
          vm.backPath = from.path;
        } else {
          vm.back = "";
        }
      });
    },
    beforeRouteLeave(to, from, next) {
      // this.searchToast.clear()
      if (this.searchToast) {
      }
      if (to.path === "/SdDoctorMsg" || to.path === "/SdDetailVideo") {
        localStorage.setItem("searchText", this.searchInput);
        next();
      } else {
        next();
      }
    },
    components: {
      DoctorItem,
      VideoBox
    },
    methods: {
      // 清除输入
      clearInput() {
        this.searchInput = "";
        this.goSearch();
      },
      // 初始化滚动
      initScroll() {
        let options = {
          proTyoe: 2,
          click: true
        };
        options.pullUpLoad = {
          threshold: -90,
          stop: -20
        };
        this.searchScroll = new BScroll(this.$refs.searchScrollRef, options);
        this.searchScroll.on("pullingUp", () => {
          this.pagingSearch();
          this.searchScroll.finishPullUp();
        });
      },
      // 分页
      pagingSearch() {
        if (this.selectFlag === 2) {
          // this.doctorList = []
          this.doctorParams.page++;
          this.fetchDoctor();
        }
        if (this.selectFlag === 1) {
          this.videoParams.page++;
          this.fetchVideo();
        }
      },
      // 搜索医生
      fetchDoctor() {
        let url = `${searchDoctor}?searchContent=${this.searchInput}&page=${
          this.doctorParams.page
        }&number=${this.doctorParams.number}`;
        this.searchToast = this.$toast({
          mask: true,
          message: "正在加载"
        });
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.searchToast.clear();
            if (res.data.data.totalPage > 0) {
              if (this.doctorParams.page > res.data.data.totalPage) {
                this.$toast("已经是最后一页了~");
              } else {
                let arry = res.data.data.doctorList;
                this.doctorList = this.doctorList.concat(arry);
                // this.searchScroll.scrollTo(0, this.searchScroll.maxScrollY)
              }
            } else {
              this.doctorList = res.data.data.doctorList;
            }
            // this.doctorList = this.doctorList.concat(res.data.data.doctorList)
          }
        });
      },
      // 搜索视频
      fetchVideo() {
        let url = `${searchVideo}?searchContent=${this.searchInput}&page=${
          this.videoParams.page
        }&number=${this.videoParams.number}`;
        const toast = this.$toast({
          mask: true,
          message: "正在加载"
        });
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            toast.clear();
            if (res.data.data.totalPage > 0) {
              if (this.videoParams.page > res.data.data.totalPage) {
                this.$toast("已经到最后一页了~");
              } else {
                let arr = res.data.data.dataList;
                //this.searchScroll.scrollTo(0, this.searchScroll.maxScrollY)
                this.videoList = this.videoList.concat(arr);
                // this.videoList = res.data.data.dataList
              }
            } else {
              this.videoList = res.data.data.dataList;
            }
          }
        });
      },
      // 选择全部 医生 或者视频
      selectNav(val) {
        this.selectFlag = val;
      },
      // return back
      goBack() {
        this.searchInput = "";
        // this.searchList.videoList = ''
        // this.searchList.doctorList = ''
        this.goSearch("no");
        // this.searchToast.clear()
        // input
        if (this.backPath) {
          if (this.backPath == "/SdSeeGroup") {
            this.$router.go(-1);
          } else {
            this.$router.push("/SdSeeDoctor");
          }
          // this.searchToast.clear()
          // this.$router.back(-1)
        } else {
          // this.searchToast.clear()
          this.$router.push("/SdSeeDoctor");
          // this.$router.back(-1)
        }
      },
      backSearch() {
        // this.$router.go(0)
        if (this.$route.query.key) {
          this.$router.back(-1);
        } else {
          location.reload();
        }
        // this.$router.push('/SdSearch')
      },
      // 获取病种列表
      getGroupList() {
        let url = searchGroupList;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.groupList = res.data.data;
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 搜索
      goSearch(val) {
        this.showBack = true;
        // event.preventDefault()
        // if (this.$route.name === '/SdSearch') {
        // if (this.$route.path === '/SdSearch') {
        if (!val) {
          this.searchToast = this.$toast({
            mask: true,
            message: "正在加载",
            duration: 500
          });
        }
        // }
        // }
        if (this.searchInput !== "") {
          if (this.$refs.search) {
            this.$refs.search.blur();
          }
          let params = {
            searchContent: this.searchInput
          };
          let url = `${searchAll}?searchContent=${params.searchContent}`;
          this.$http.get(url).then(res => {
            if (res.data.code == 0) {
              if (this.searchToast) {
                this.searchToast.clear();
              }
              this.searchList = res.data.data;
              this.selectFlag = 0;
              this.doctorList = this.searchList.doctorList;
              this.videoList = this.searchList.videoList;
              this.getKeyword();
              this.nullTextJuge();
              // this.$nextTick(() => {
              //   this.searchScroll.scrollTo(0, 0)
              // })
            } else {
              this.$toast(res.data.message);
            }
          });
          this.keyFlag = false;
        } else {
          // this.$toast('输入信息不能为空')
          this.searchList = {
            videoList: [],
            doctorList: []
          };
          this.videoList = "";
          this.doctorList = "";
          this.keyFlag = true;
          this.navFlag = false;
          this.allFlag = true;
          this.showFlag = false;
        }
      },
      // 获取最近搜索
      getKeyword() {
        let url = searchKeyWord;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.keyWords = res.data.data;
          } else {
            // this.$toast(res.data.message)
          }
        });
      },
      // 清除历史搜索
      clearKeyword() {
        let url = searchClearKeyWord;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.$toast("清除成功");
            this.getKeyword();
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 判断空文本
      nullTextJuge() {
        if (this.searchList) {
          if (
            this.searchList.videoList.length === 0 &&
            this.selectFlag === 1 &&
            this.searchList.doctorList.length !== 0
          ) {
            this.showFlag = true;
            this.allFlag = true;
          } else if (
            this.searchList.doctorList.length === 0 &&
            this.selectFlag === 2 &&
            this.searchList.videoList.length !== 0
          ) {
            this.showFlag = true;
            this.allFlag = true;
          } else if (
            this.searchList.doctorList.length === 0 &&
            this.searchList.videoList.length === 0
          ) {
            this.showFlag = true;
            this.allFlag = true;
            this.navFlag = false;
          } else {
            this.showFlag = false;
            this.navFlag = true;
            this.allFlag = false;
            this.keyFlag = false;
          }
        }
      },
      // 标签搜索
      tipsSearch(val) {
        if (val) {
          this.searchInput = val.group_name || val.keyword || val;
          this.searchTips = this.searchInput;
          this.goSearch();
        }
      },
      goRouter(val) {
        this.$router.push(val);
      }
    },
    computed: {
      nullText() {
        if (this.searchList) {
          if (
            this.searchList.videoList.length === 0 &&
            this.selectFlag === 1 &&
            this.searchList.doctorList.length !== 0
          ) {
            return "没有找到相关视频";
          } else if (
            this.searchList.doctorList.length === 0 &&
            this.selectFlag === 2 &&
            this.searchList.videoList.length !== 0
          ) {
            return "没有找到相关医生";
          } else if (
            this.searchList.doctorList.length === 0 &&
            this.searchList.videoList.length === 0
          ) {
            return "没有找到相关视频和医生";
          }
        }
      }
    }
  };
</script>

<style lang="postcss" scoped>
  #sd-search {
    /* padding: 0 30px; */
    /* height: 100%; */
    background-color: #fffffd;
    & header {
      position: fixed;
      top: 0;
      left: 0;
      padding: 0 30px;
      width: 100%;
      box-sizing: border-box;
      z-index: 999;
      background-color: #fffffd;
    }
    & .index-content {
      /* padding: 0 30px; */
      padding-top: 130px;
      & .text-wrapper {
        background-color: #fffffd;
        position: absolute;
        z-index: 998;
        padding: 0 30px;
      }
    }
    & .nullIndex {
      padding-top: 0;
    }
    & .search-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 40px 0;
      & .back-icon {
        width: 16px;
        height: 32px;
        padding: 10px;
        /* background-color: red; */
      }
      & .search-box {
        display: flex;
        width: 100%;
        position: relative;
        & .form-input {
          width: 100%;
          box-sizing: border-box;
          /* background-color: red; */
          display: flex;
        }
        & .search-text {
          background-color: #fffffd;
          width: 100%;
          height: 80px;
          line-height: normal;
          font-size: 28px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          border: 2px solid rgba(215, 215, 215, 1);
          border-radius: 39px;
          box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.08);
          /* margin: 0 30px; */
          padding-left: 82px;
          /* text-align: center; */
          /* box-sizing: border-box; */
        }
        & .search-icon {
          position: absolute;
          top: 50%;
          margin-top: -19px;
          left: 30px;
          height: 38px;
          width: 38px;
        }
        & .close-icon {
          width: 38px;
          height: 38px;
          position: absolute;
          right: 30px;
          top: 50%;
          margin-top: -19px;
        }
      }
      & .back-text {
        text-align: right;
        position: relative;
        right: 0;
        width: 90px;
        font-size: 30px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
    & .activeSearch {
      & .search-text {
        margin: 0 0 0 30px;
      }
      & .search-icon {
        left: 60px !important;
      }
    }
    & .recent-search {
      padding-bottom: 21px;
      border-bottom: 1px solid rgba(215, 215, 215, 1);
    }
    & .search-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 40px 0 23px 0;
      & .title-text {
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      & .delete-search {
        font-size: 26px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
    & .search-list {
      width: 100%;
      display: flex;
      /* justify-content: space-between; */
      flex-wrap: wrap;
      & .item-text {
        width: 33%;
        font-size: 28px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 60px;
        display: flex;
        /* justify-content: left; */
      }
    }
    & .all-video {
      & .all-text {
        margin-top: 50px;
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      & .ask-gif {
        width: 100%;
      }
      & .all-box {
        & li:last-child {
          padding-bottom: 50px;
        }
        & .search-list li:last-child {
          /* background-color: yellow; */
          padding-bottom: 0;
        }
      }
    }
    & .search-nav {
      margin-bottom: 50px;
      & .nav-wrapper {
        display: flex;
        & .nav-text {
          font-size: 36px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
        & .activeNav {
          font-size: 36px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
      }
      & .nav-wrapper li:nth-child(2) {
        margin: 0 53px;
        padding: 0 50px;
        border-left: 1px solid rgba(215, 215, 215, 1);
        border-right: 1px solid rgba(215, 215, 215, 1);
      }
    }
    & .null-wrapper {
      padding-top: 270px;
      padding-bottom: 60px;
      border-bottom: 1px solid rgba(215, 215, 215, 1);
      & .img-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        & .null-img {
          width: 330px;
          height: 330px;
        }
      }
      & .null-text {
        font-size: 30px;
        font-family: SourceHanSansCN-Regular;
        color: rgba(153, 153, 153, 1);
        margin-top: 40px;
      }
    }
    & .search-scroll {
      z-index: 1;
      /* position: absolute;
            height: 100%;
            top: 0; */
      pointer-events: auto;
      /* height: 1088px; */
      width: 100%;
      /* overflow: hidden; */
      /* margin-top: 113px; */
      box-sizing: border-box;
    }
    & .search-wrapper {
      /* position: absolute; */
      /* overflow: hidden; */
      position: relative;
      /* top: 226px; */
      padding-top: 118px;
      /* height: 100%; */
      /* margin-top: 250px; */
      /* margin-top: 150px; */
    }
    & .doctor-list {
      padding: 0 30px;
      padding-top: 1px;
      /* margin-top: 30px; */
      /* margin-top: 113px; */
      & li:first-child {
        & #doctor-detail {
          /* border-top: 1px solid rgba(215, 215, 215, 1) !important; */
          /* padding-top: px; */
          & .doctor-left {
            /* padding-top: 10px; */
          }
        }
      }
    }
    & .button-wrapper {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      padding: 60px 0 90px 0;
      /* background-color: red; */
      & .more-button {
        width: 180px;
        height: 54px;
        border: 1px solid rgba(55, 189, 25, 1);
        border-radius: 27px;
        font-size: 28px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        background-color: #fffffd;
        color: rgba(55, 189, 25, 1);
      }
    }
    & .video-list {
      /* margin-top: 113px; */
      /* border-bottom: 1px solid rgba(215,215,215,1); */
      margin-bottom: 60px;
      /* position: absolute; */
      left: 0;
      & .list-item {
        margin: 30px 30px;
        border-radius: 8px;
        box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background-color: #fff;
        overflow: hidden;
      }
      & .list-item:first-child {
        margin-top: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduSearch/SdSearch.vue